import { createGlobalStyle } from 'styled-components';
const CDN = process.env.CDN_URL;
export const InterFontFace = createGlobalStyle `
  @font-face {
    font-family: "Inter var";
    font-display: swap;
    src: url(${CDN}/fonts/inter/inter.var.woff2) format("woff2");
  }
`;
